module.exports = __webpack_public_path__ + "ca346d3e5b96ea5988ebd9a0125c27a8.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/guitar/15_D3.mp3
// module id = 73
// module chunks = 0